// ================================
// SUVENE QUICKADD
// ================================

(function () {
  'use strict';

function openCartDrawer() {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  // Erst Cart-Inhalt refreshen, dann öffnen
  document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { bubbles: true }));
  
  setTimeout(() => {
    if (!drawer.hasAttribute('open')) {
      drawer.toggleDrawerClasses();
    }
  }, 300);
}

  async function addToCart(variantId, buttonEl) {
    buttonEl.classList.add('is-loading');

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId), quantity: 1 }]
        })
      });

      if (!response.ok) throw new Error('Cart add failed');

      // Cart count updaten
      await fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          // Bubble/Badge updaten
          const countEls = document.querySelectorAll('[data-cart-count], .cart-count-bubble span, .wt-cart__count');
          countEls.forEach(el => { el.textContent = cart.item_count; });
        });

      // Größen-Panel schließen
      const panel = buttonEl.closest('.suvene-quickadd');
      if (panel) closePanel(panel);

      // Cart Drawer öffnen
      openCartDrawer();

    } catch (err) {
      console.error('Suvene QuickAdd Error:', err);
    } finally {
      buttonEl.classList.remove('is-loading');
    }
  }

  function closePanel(panel) {
    panel.classList.remove('is-open');
    const trigger = panel.querySelector('.suvene-quickadd__trigger');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    const sizes = panel.querySelector('.suvene-quickadd__sizes');
    if (sizes) sizes.setAttribute('aria-hidden', 'true');
  }

  function openPanel(panel) {
    // Alle anderen schließen
    document.querySelectorAll('.suvene-quickadd.is-open').forEach(p => {
      if (p !== panel) closePanel(p);
    });

    panel.classList.add('is-open');
    const trigger = panel.querySelector('.suvene-quickadd__trigger');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    const sizes = panel.querySelector('.suvene-quickadd__sizes');
    if (sizes) sizes.setAttribute('aria-hidden', 'false');
  }

  function initQuickAdd() {
    // Trigger Buttons (+ Icon)
    document.querySelectorAll('.suvene-quickadd__trigger').forEach(trigger => {
      if (trigger.dataset.initialized) return;
      trigger.dataset.initialized = 'true';
      trigger.tabIndex = 0;

      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const panel = trigger.closest('.suvene-quickadd');

        // Single variant: direkt in den Warenkorb
        if (trigger.classList.contains('suvene-quickadd__trigger--single')) {
          const variantId = trigger.dataset.variantId;
          if (variantId) addToCart(variantId, trigger);
          return;
        }

        // Multi variant: Toggle Panel
        if (panel.classList.contains('is-open')) {
          closePanel(panel);
        } else {
          openPanel(panel);
        }
      });
    });

    // Größen-Buttons
    document.querySelectorAll('.suvene-quickadd__size-btn').forEach(btn => {
      if (btn.dataset.initialized) return;
      btn.dataset.initialized = 'true';
      btn.tabIndex = 0;

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const variantId = btn.dataset.variantId;
        if (variantId) addToCart(variantId, btn);
      });
    });
  }

  // Beim Laden initialisieren
  document.addEventListener('DOMContentLoaded', initQuickAdd);

  // Re-init nach dynamischen Loads (z.B. infinite scroll, filters)
  document.addEventListener('shopify:section:load', initQuickAdd);

  // Falls dein Theme Produkte dynamisch nachlädt
  const observer = new MutationObserver(() => initQuickAdd());
  observer.observe(document.body, { childList: true, subtree: true });

  // Außerhalb klicken → schließen
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.suvene-quickadd')) {
      document.querySelectorAll('.suvene-quickadd.is-open').forEach(closePanel);
    }
  });

})();